import { AsYouType, parsePhoneNumberFromString } from "libphonenumber-js/max";

const LOCALE_COUNTRY_MAP = {
  tr: "TR",
  en: "US",
};

const FALLBACK_COUNTRY = "US";

function parsePhone(value, country) {
  if (!value) return null;
  try {
    return parsePhoneNumberFromString(value, country);
  } catch {
    return null;
  }
}

function resolveCountry(locale) {
  if (!locale) return FALLBACK_COUNTRY;
  const normalized = locale.split("-")[0]?.toLowerCase();
  return LOCALE_COUNTRY_MAP[normalized] || FALLBACK_COUNTRY;
}

export function getDefaultPhoneCountry(locale) {
  return resolveCountry(locale);
}

export function formatPhoneInput(value, country) {
  if (!value) return "";
  try {
    const formatter = new AsYouType(country);
    return formatter.input(value);
  } catch (error) {
    return value;
  }
}

export function normalizePhoneNumber(value, country) {
  const parsed = parsePhone(value, country);
  if (parsed) return parsed.number;
  return value?.trim() || "";
}

export function isPhoneValid(value, country) {
  const parsed = parsePhone(value, country);
  return Boolean(parsed?.isValid());
}
